// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Тень фона */
.CreateStaffModal_overlay__OtHrj {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  backdrop-filter: blur(2px);
}

.CreateStaffModal_input__jb8Ow {
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #d0d6da;
  background: #fff;
  font-size: 14px;
}

/* Само окно */
.CreateStaffModal_modal__FfKXD {
  position: relative;
  background: #ffffff;
  padding: 32px 28px;
  border-radius: 16px;
  width: 400px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  animation: CreateStaffModal_fadeIn__4p2Z6 0.3s ease;
}

/* Кнопка закрытия */
.CreateStaffModal_close__mG1G4 {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #666;
  transition: color 0.2s;
}

.CreateStaffModal_close__mG1G4:hover {
  color: #000;
}

/* Заголовок */
.CreateStaffModal_title__xKL9Y {
  text-align: center;
  margin-bottom: 20px;
  font-size: 20px;
  color: #222;
}

/* Форма */
.CreateStaffModal_form__m6L78 {
  display: flex;
  flex-direction: column;
}

.CreateStaffModal_label__VNxP1 {
  margin-top: 10px;
  font-size: 14px;
  color: #444;
  text-align: left;
}

.CreateStaffModal_submitBtn__MoFot {
  margin-top: 18px;
  padding: 12px;
  background: rgba(29, 135, 82, 1);
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s;
}

.CreateStaffModal_submitBtn__MoFot:hover {
  background: rgb(20, 70, 45);
}

@keyframes CreateStaffModal_fadeIn__4p2Z6 {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.CreateStaffModal_tempPasswordBox__Smwj1 {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border: 1px solid #ccc;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  border-radius: 8px;
  z-index: 10000;
}

.CreateStaffModal_copyBtn__jQ7dj {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

.CreateStaffModal_okBtn__tzkfz {
  background: rgba(29, 135, 82, 1);
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}


`, "",{"version":3,"sources":["webpack://./src/pages/StaffPages/modals/CreateStaffModal.module.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;EAC3C,mDAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["/* Тень фона */\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n  backdrop-filter: blur(2px);\n}\n\n.input {\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #d0d6da;\n  background: #fff;\n  font-size: 14px;\n}\n\n/* Само окно */\n.modal {\n  position: relative;\n  background: #ffffff;\n  padding: 32px 28px;\n  border-radius: 16px;\n  width: 400px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n  animation: fadeIn 0.3s ease;\n}\n\n/* Кнопка закрытия */\n.close {\n  position: absolute;\n  top: 12px;\n  right: 16px;\n  background: none;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n  color: #666;\n  transition: color 0.2s;\n}\n\n.close:hover {\n  color: #000;\n}\n\n/* Заголовок */\n.title {\n  text-align: center;\n  margin-bottom: 20px;\n  font-size: 20px;\n  color: #222;\n}\n\n/* Форма */\n.form {\n  display: flex;\n  flex-direction: column;\n}\n\n.label {\n  margin-top: 10px;\n  font-size: 14px;\n  color: #444;\n  text-align: left;\n}\n\n.submitBtn {\n  margin-top: 18px;\n  padding: 12px;\n  background: rgba(29, 135, 82, 1);\n  border: none;\n  border-radius: 10px;\n  color: white;\n  font-size: 15px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.submitBtn:hover {\n  background: rgb(20, 70, 45);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.tempPasswordBox {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #fff;\n  border: 1px solid #ccc;\n  padding: 12px 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.2);\n  border-radius: 8px;\n  z-index: 10000;\n}\n\n.copyBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.okBtn {\n  background: rgba(29, 135, 82, 1);\n  color: #fff;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `CreateStaffModal_overlay__OtHrj`,
	"input": `CreateStaffModal_input__jb8Ow`,
	"modal": `CreateStaffModal_modal__FfKXD`,
	"fadeIn": `CreateStaffModal_fadeIn__4p2Z6`,
	"close": `CreateStaffModal_close__mG1G4`,
	"title": `CreateStaffModal_title__xKL9Y`,
	"form": `CreateStaffModal_form__m6L78`,
	"label": `CreateStaffModal_label__VNxP1`,
	"submitBtn": `CreateStaffModal_submitBtn__MoFot`,
	"tempPasswordBox": `CreateStaffModal_tempPasswordBox__Smwj1`,
	"copyBtn": `CreateStaffModal_copyBtn__jQ7dj`,
	"okBtn": `CreateStaffModal_okBtn__tzkfz`
};
export default ___CSS_LOADER_EXPORT___;
